import React from 'react'
import {
  ONE_HOTEL_IMAGE,
  FOUR_SEASONS_IMAGE,
  FORBES_IMAGE,
  TRAVEL_AND_LEISURE_IMAGE,
} from '../../helpers/constants'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-section='awards-press'>
      <p data-type='subtitle'>Selected Awards & Press</p>
      <p data-type='description'>
        We collaborate with leading firms and brands on projects that win awards for outstanding
        vision and design, and our work is often highlighted by the press.
      </p>
      <div data-type='award' data-style='text-first'>
        <div data-type='text'>
          <p data-type='award-name'>Winner of 2022 gold key awards</p>
          <p data-type='hotel-name'>1 Hotel Toronto</p>
          <p data-type='award-title'>Best Luxury Hotel</p>
        </div>
        <picture data-type='image'>
          <img
            width='876'
            height='620'
            itemProp='image'
            className='lazyload'
            data-src={ONE_HOTEL_IMAGE}
            alt='1hotel'
            role='presentation'
            data-type='image'
          />
        </picture>
      </div>
      <div data-type='award' data-style='image-first'>
        <picture data-type='image'>
          <img
            width='876'
            height='620'
            itemProp='image'
            className='lazyload'
            data-src={FOUR_SEASONS_IMAGE}
            alt='four seasons'
            role='presentation'
            data-type='image'
          />
        </picture>
        <div data-type='text'>
          <p data-type='award-name'>Winner of 2020 hd awards</p>
          <p data-type='hotel-name'>Four Seasons</p>
          <p data-type='location'>New Orleans</p>
          <p data-type='award-title'>Best Luxury Guest Room</p>
        </div>
      </div>
      <div data-type='press' data-style='text-first'>
        <div data-type='text-section'>
          <div data-type='text'>
            <p data-type='quote'>
              "Michigan's Coolest New Luxury Hotel Is in a City You've Never Heard Of"
            </p>
            <p data-type='press-name'>—Travel & Leisure</p>
            <p data-type='location'>on the Daxton Hotel</p>
          </div>
          <div data-type='text' data-style='additional-text'>
            <p data-type='quote'>
              "This Art-Filled Hotel Is Like Stepping Into A Cool Museum With Room Service"
            </p>
            <p data-type='press-name'>—Forbes</p>
            <p data-type='location'>on Life House, Berkshires</p>
          </div>
        </div>
        <picture data-type='image'>
          <img
            width='876'
            height='620'
            itemProp='image'
            className='lazyload'
            data-src={FORBES_IMAGE}
            alt='forbes'
            role='presentation'
            data-type='image'
          />
        </picture>
      </div>
      <div data-type='press' data-style='image-first'>
        <picture data-type='image'>
          <img
            width='876'
            height='620'
            itemProp='image'
            className='lazyload'
            data-src={TRAVEL_AND_LEISURE_IMAGE}
            alt='travel and leisure'
            role='presentation'
            data-type='image'
          />
        </picture>
        <div data-type='text-section'>
          <div data-type='text'>
            <p data-type='quote'>
              "This Small Town in Massachusetts Just Got a New Hotel — and It's the Perfect Spot for
              a Fall Getaway"
            </p>
            <p data-type='press-name'>—Travel & Leisure</p>
            <p data-type='location'>on the Daxton Hotel</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component